import * as yup from 'yup'

export const greenListFormSchema = yup.object().shape({
    email: yup
        .string()
        .trim()
        .required('El campo correo electronico es requerido.')
        .email('El campo correo electronico no es valido.')
})